var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 41.5L62.5 42L86.5 61.5L9 87L21 41.5Z",
    fill: "#CFC8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 97.5H87L64 78L105.5 64.5L114 97.5Z",
    fill: "#CFC8FF",
    fillOpacity: 0.51
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.713 97.5H5.8313L20.4188 41.25H23.3625M59.2688 41.25H99.5813L114.169 97.5",
    stroke: "#302E6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.463 56.2312L94.0126 59.2875H93.9939M86.9814 61.5562L56.1939 71.4937L49.1439 73.7625L8.6064 86.85H8.58765M23.5689 90.7874L56.7376 80.0812L70.4064 91.4812M99.4689 66.2812L94.5564 67.875L63.7501 77.8125L87.3751 97.5",
    stroke: "#302E6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0125 59.2875H93.9937L79.4062 47.1187M86.9812 61.5563L62.625 41.25",
    stroke: "#302E6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2501 47.5125C48.1572 47.5125 53.7564 41.9133 53.7564 35.0063C53.7564 28.0992 48.1572 22.5 41.2501 22.5C34.3431 22.5 28.7439 28.0992 28.7439 35.0063C28.7439 41.9133 34.3431 47.5125 41.2501 47.5125Z",
    fill: "#302E6B",
    stroke: "#302E6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5422 28.2373C43.6219 28.4497 44.6355 28.9158 45.4994 29.5971C46.3634 30.2785 47.0529 31.1556 47.511 32.1561",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 47.4937V62.0812",
    stroke: "#302E6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.278,
    cy: 22.2778,
    r: 9.16667,
    fill: "#714FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0723 14.9302C34.7079 16.5664 35.7256 18.7191 35.952 21.0215C36.1784 23.3239 35.5995 25.6335 34.3139 27.5569C33.0283 29.4803 31.1156 30.8985 28.9016 31.5698C26.6876 32.2411 24.3094 32.1239 22.1721 31.2384C20.0348 30.3528 18.2707 28.7535 17.1803 26.7131C16.09 24.6727 15.7408 22.3173 16.1923 20.0483C16.6438 17.7793 17.8681 15.737 19.6566 14.2695C21.445 12.8019 23.687 11.9999 26.0005 12C27.3139 12.0001 28.6145 12.2589 29.8279 12.7616C31.0413 13.2644 32.1438 14.0013 33.0723 14.9302ZM31.7452 27.7427C33.076 26.4119 33.904 24.6609 34.0883 22.788C34.2725 20.915 33.8016 19.0362 32.7557 17.4716C31.7098 15.907 30.1537 14.7536 28.3526 14.2078C26.5515 13.6621 24.6169 13.7578 22.8785 14.4787C21.1401 15.1996 19.7055 16.5011 18.8192 18.1612C17.9328 19.8214 17.6497 21.7376 18.0179 23.5832C18.3862 25.4288 19.3831 27.0895 20.8387 28.2824C22.2943 29.4753 24.1185 30.1265 26.0005 30.125C28.1548 30.1243 30.2208 29.269 31.7452 27.7469V27.7427ZM27.4078 17.4521V22.4521C27.415 22.6413 27.3841 22.8301 27.3167 23.007C27.2493 23.184 27.1469 23.3455 27.0156 23.482C26.8843 23.6185 26.7268 23.727 26.5525 23.8011C26.3783 23.8753 26.1909 23.9135 26.0015 23.9135C25.8121 23.9135 25.6247 23.8753 25.4505 23.8011C25.2762 23.727 25.1187 23.6185 24.9874 23.482C24.8561 23.3455 24.7537 23.184 24.6863 23.007C24.619 22.8301 24.588 22.6413 24.5953 22.4521V17.4521C24.6093 17.0885 24.7635 16.7444 25.0257 16.4922C25.2879 16.2399 25.6376 16.0989 26.0015 16.0989C26.3654 16.0989 26.7151 16.2399 26.9773 16.4922C27.2395 16.7444 27.3938 17.0885 27.4078 17.4521ZM27.3911 26.5146C27.3849 26.7882 27.2982 27.0539 27.1417 27.2785C26.9852 27.503 26.7659 27.6764 26.5113 27.7769C26.2568 27.8773 25.9782 27.9005 25.7105 27.8433C25.4429 27.7862 25.198 27.6513 25.0066 27.4557C24.8153 27.26 24.6859 27.0122 24.6347 26.7433C24.5835 26.4745 24.6129 26.1965 24.719 25.9442C24.8251 25.6919 25.0033 25.4765 25.2312 25.3251C25.4592 25.1736 25.7268 25.0928 26.0005 25.0927C26.1854 25.0946 26.3682 25.133 26.5383 25.2057C26.7084 25.2784 26.8625 25.384 26.9917 25.5164C27.1209 25.6488 27.2227 25.8054 27.2912 25.9772C27.3598 26.1491 27.3937 26.3327 27.3911 26.5177V26.5146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDenied);
export default __webpack_public_path__ + "static/media/location-denied.c0ba9f24cb0d5fa77ddc10002e53fb50.svg";
export { ForwardRef as ReactComponent };